module.exports = __webpack_public_path__ + "img/taili.1dac0ea1.jpg";